var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showTextBlock)?_c('v-card',{staticClass:"encounter-card",attrs:{"height":_vm.minHeight}},[_c('div',{staticClass:"encounter-card-scrim"},[_c('span',{staticClass:"encounter-card-title"},[_vm._v(_vm._s(_vm.encounter.encounterType.name))]),_c('span',{staticClass:"encounter-card-description"},[_vm._v(_vm._s(_vm.displayDescription))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }